import React, { useState } from 'react';
import { Drawer, DrawerProps } from '@mui/material';
import { FaFacebook, FaWhatsapp, FaTelegram, FaEnvelope, FaViber, FaLink } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

import { LoggerService } from '../../utils';
import './Drawer.scss';

interface ShareDrawerProps extends DrawerProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  isAdmin?: string;
  programUrl: string;
  programTitle: string;
  programMessage?: string;
  channels?: Array<'FaFacebook' | 'FaWhatsapp' | 'FaTelegram' | 'FaEnvelope' | 'FaViber' | 'FaLink'>;
}

const defaultChannels = ['FaFacebook', 'FaWhatsapp', 'FaTelegram', 'FaViber', 'FaEnvelope', 'FaLink']
const ShareDrawer: React.FC<ShareDrawerProps> = ({ open, onClose = () => { }, title, programUrl, programTitle, programMessage = programUrl, isAdmin = false, channels = defaultChannels, ...props }) => {
  const { t } = useTranslation();
  
  const [isCopied, setIsCopied] = useState(false);
  const isIOS = (): boolean => {
    if (typeof window !== 'undefined') {
      return /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }
    return false;
  };
  // const { addToast,deleteToast } = useToast();

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      LoggerService.log('Failed to copy', { variant: 'error' });
    }
  };


  const renderChannelIcon = (channel: string) => {
    switch (channel) {
      case 'FaFacebook':
        return (
          <div className="drawer-share-icon" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(programMessage)}&t=${programTitle}`)}>
            <FaFacebook size="40px" /> <div className="drawer-share-label">Facebook</div>
          </div>
        );
      case 'FaWhatsapp':
        return (
          <div className="drawer-share-icon" onClick={() => window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(programMessage)}`)}>
            <FaWhatsapp size="40px" /> <div className="drawer-share-label">Whatsapp</div>
          </div>
        );
      case 'FaTelegram':
        return (
          <div className="drawer-share-icon" onClick={() => window.open(`https://telegram.me/share/url?url=${encodeURIComponent(programMessage)}`)}>
            <FaTelegram size="40px" /> <div className="drawer-share-label">Telegram</div>
          </div>
        );
      case 'FaViber':
        return (
          <div className="drawer-share-icon" onClick={() => window.open(`viber://forward?text=${encodeURIComponent(programMessage)}`)}>
            <FaViber size="40px" /> <div className="drawer-share-label">Viber</div>
          </div>
        );
      case 'FaEnvelope':
        return (
          <div className="drawer-share-icon" onClick={() => window.open(`mailto:?subject=${programTitle}&body=${encodeURIComponent(programMessage)}`)}>
            <FaEnvelope size="40px" /> <div className="drawer-share-label">Email</div>
          </div>
        );
      case 'FaLink':
        return (
          <div className="drawer-share-icon" onClick={() => copyToClipboard(`${programUrl}`)}>
            <FaLink size="40px" /> <div className="drawer-share-label">{isAdmin
              ? t('admin.shareLink.copyLink')
              : t('dashboard.shareLink.copyLink')
            }
          </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Drawer
      open={open}
      anchor={'bottom'}
      onClose={onClose}
      {...props}
      classes={{ paper: isIOS() ? 'styles.paper_container_iOS' : 'styles.paper_container' }}
    >
      <div className="drawer-share">
        <div className="drawer-title">
          <div>{title}</div>
          <div className="drawer-burger-menu active" onClick={onClose}>
            <div className="bar top"></div>
            <div className="bar middle"></div>
            <div className="bar bottom"></div>
          </div>
        </div>
        <div className="divider" />
        <div className="drawer-share-list">
          {channels.map(channel => renderChannelIcon(channel))}
        </div>
      </div>
      <div className={`drawer-copied ${isCopied ? 'isCopied' : ''}`}>{'Copied!'}</div>
    </Drawer>
  );
};

export default ShareDrawer;
